"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocalStorageState = void 0;
const react_1 = require("react");
function useLocalStorageState(key, defaultState) {
    const [state, setState] = (0, react_1.useState)(() => {
        // NOTE: Not sure if this is ok
        if (typeof window !== "undefined") {
            const storedState = localStorage.getItem(key);
            if (storedState) {
                return JSON.parse(storedState);
            }
        }
        return defaultState;
    });
    const setLocalStorageState = (0, react_1.useCallback)((newState) => {
        const changed = state !== newState;
        if (!changed) {
            return;
        }
        setState(newState);
        if (newState === null) {
            localStorage.removeItem(key);
        }
        else {
            localStorage.setItem(key, JSON.stringify(newState));
        }
    }, [state, key]);
    return [state, setLocalStorageState];
}
exports.useLocalStorageState = useLocalStorageState;
//# sourceMappingURL=useLocalStorageState.js.map